<template>
  <div class="appSelect">
    <v-select
      v-model="model"
      :items="mappedItems"
      :placeholder="defaultLabel"
      menu-props="auto"
      outlined
      :disabled="disabled"
      hide-details
      :item-text="itemText"
      :item-value="itemValue"
      @change="$emit('change', $event)"
    />
    <h5
      v-if="label"
      class="appSelect-label"
      :class="{ 'appSelect-label--disabled': disabled }"
    >
      {{ label }}
    </h5>
  </div>
</template>

<script>
export default {
  name: 'AppSelect',
  props: {
    value: {
      type: [Number, String, Object],
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    defaultLabel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: null,
    },
    itemValue: {
      type: String,
      default: null,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    mappedItems() {
      return this.items;
    },
  },
};
</script>
<style lang="scss" scoped>
.appSelect {
  display: flex;
  align-items: baseline;
  &::v-deep .v-text-field .v-input__append-inner {
    height: 100%;
    margin-top: 0;
    background-color: #CC0000;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &::v-deep
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    padding-right: 0;
    min-height: 50px;
    max-height: 50px;
    background-color: #fff;
  }
  &::v-deep .v-input__icon.v-input__icon--append {
    height: unset;
    width: 40px;
    .v-icon {
      color: #fff;
      font-size: 37px;
      &.primary--text {
        color: #fff !important;
      }
    }
  }
  &::v-deep .v-text-field--outlined fieldset {
    border-color: #CC0000;
  }
  &::v-deep .v-select__selection {
    &--comma {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #333;
      width: 100%;
    }
  }
  &::v-deep .v-select__selections {
    input::placeholder {
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      color: #333;
    }
  }
  &::v-deep .v-text-field__details {
    display: none;
  }
  &::v-deep
    .v-select__selection.v-select__selection--comma.v-select__selection--disabled {
    color: #ccc;
  }
  &::v-deep .v-input--is-disabled:not(.v-input--is-readonly) {
    & .v-select__selections {
      input::placeholder {
        color: #ccc;
      }
    }
    &.v-text-field--outlined fieldset {
      border-color: #ccc;
    }
    & .v-input__control > .v-input__slot {
      background-color: #f4f4f4 !important;
    }
    & .v-input__append-inner {
      background-color: #ccc;
    }
    & .theme--light.v-icon.v-icon.v-icon--disabled {
      color: #fff !important;
    }
  }

  &-label {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #333;
    margin-left: 10px;
    flex-shrink: 0;
    &--disabled {
      color: #ccc;
    }
  }
  & > h5 {
    margin-bottom: 0;
  }
}
</style>
